module.exports = __webpack_public_path__ + "static/img/200321.87e5aa93.png";